import { toVehicleReference } from "./to-vehicle-reference";
import type { VehicleLite } from "../../types/vehicle.types";
import type { VehicleLiteDto } from "@/lib/api";
import { toOwner } from "@/utils/mappers/to-owner";

export function toVehicleLite(dto: VehicleLiteDto): VehicleLite {
	return {
		id: dto.vehicle.id,
		vehicle: toVehicleReference(dto.vehicle),
		owner: toOwner(dto.owner),
	};
}
